import { render } from "./ListaClientes.vue?vue&type=template&id=1759dc7b"
import script from "./ListaClientes.vue?vue&type=script&lang=js"
export * from "./ListaClientes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__